import * as React from "react"
import { PartyRole } from "@digits-graphql/frontend/graphql-bearer"
import { useAnalysisCategoryTypes } from "src/frontend/components/OS/Applications/Analysis/AnalysisCategoryTypesContext"
import { TopActivity } from "src/frontend/components/OS/Shared/Widgets/TopActivities/shared"
import { TopActivitiesSelector } from "src/frontend/components/OS/Shared/Widgets/TopActivities/TopActivitiesSelector"
import { TopCategories } from "src/frontend/components/OS/Shared/Widgets/TopActivities/TopCategories"
import { TopParties } from "src/frontend/components/OS/Shared/Widgets/TopActivities/TopParties"
import { TopTransactions } from "src/frontend/components/OS/Shared/Widgets/TopActivities/TopTransactions"
import { WidgetGrid } from "src/frontend/components/OS/Shared/Widgets/WidgetGrid"

/*
  COMPONENTS
*/

export const RevenueOverviewHighlights: React.FC = () => {
  const [activeHighlight, setActiveHighlight] = React.useState(TopActivity.Largest)
  const categoryTypes = useAnalysisCategoryTypes()

  return (
    <>
      <TopActivitiesSelector
        activeHighlight={activeHighlight}
        setActiveHighlight={setActiveHighlight}
      ></TopActivitiesSelector>

      <WidgetGrid>
        <TopCategories categoryTypes={categoryTypes} highlight={activeHighlight} />
        <TopParties
          partyRole={PartyRole.EntityCustomerRole}
          categoryTypes={categoryTypes}
          highlight={activeHighlight}
        />
        <TopTransactions categoryTypes={categoryTypes} highlight={activeHighlight} />
      </WidgetGrid>
    </>
  )
}
